export default __webpack_public_path__ + "static/media/logo-mobile.14febe8c.svg";